export default import.meta.ROLLUP_FILE_URL_479VhuutRPKqW_6Ht6iXzA;